<template>
  <v-col cols="1">
    <v-menu :close-on-content-click="false">
      <template #activator="{ props: activatorProps }">
        <v-btn
          icon="fa-solid fa-circle-a"
          :color="value"
          variant="text"
          v-bind="activatorProps"
          size="small"
          :disabled="loading"
        />
      </template>
      <v-color-picker
        v-model="value"
        mode="hexa"
        @update:model-value="setColor"
      />
    </v-menu>
  </v-col>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { Editor } from '@tiptap/vue-3'

const props = defineProps<{
  editor: Editor
  loading?: boolean
}>()

const value = ref('#000000')

const setColor = (hex: string) => {
  props.editor.commands.setColor(hex)
}
</script>
